<template>
  <div class="survey-stat">
    <div class="stat-main">
      <div class="actionBar">
        <div class="function">
          <div
            v-for="(item, index) in tabs"
            :key="index"
            :class="['item', { active: activeIndex === index }]"
            @click="clickItem(index, item.route)"
          >
            <img :src="activeIndex === index ? item.active : item.inactive" />
            {{
              item.label
            }}
          </div>
        </div>
        <!-- 答卷详情页不显示 -->
        <div v-if="show" class="download">
          <span class="item" @click="downloadData">
            <img src="@/assets/images/survey/stat/download.svg" />
            {{ activeIndex == 0 ? "下载调查数据" : "下载分析数据" }}
          </span>

          <span class="item" slot="reference" @click="downloadMedia">
            <img src="@/assets/images/survey/stat/download.svg" />下载媒体
          </span>
        </div>
      </div>
      <router-view></router-view>
    </div>
    <el-dialog
      :visible="downloadDialog.visible"
      :title="downloadDialog.title"
      width="400px"
      @close="downloadDialog.visible = false"
    >
      <div class="dialog-body">
        <img src="~@/assets/images/survey/stat/zip.svg" />
        <div class="info">
          <div class="title">{{ downloadDialog.url ? "文件正在下载" : "文件正在压缩" }}</div>
          <div class="desc">
            {{
              downloadDialog.url ? "压缩已经开始下载" : "压缩完成将自动开始下载"
            }}
          </div>
        </div>
        <i class="el-icon-loading" id="loading" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import nanswer from "@/assets/images/survey/stat/nanswer.svg";
import answer from "@/assets/images/survey/stat/answer.svg";
import nanalyze from "@/assets/images/survey/stat/nanalysis.svg";
import analyze from "@/assets/images/survey/stat/analysis.svg";
import {
  exportAnswer,
  exportAnalyze,
  exportMedias
} from "@/api/stat";

const tabs = [{
  label: "答卷",
  active: answer,
  inactive: nanswer,
  route: "SurveyAnswers",
},
{
  label: "分析",
  active: analyze,
  inactive: nanalyze,
  route: "SurveyAnalyze",
},
];
export default {
  data() {
    return {
      activeIndex: 0,
      tabs,
      downloadDialog: {
        visible: false,
        title: "正在生成"
      },
    };
  },
  computed: {
    id() {
      let id = this.$route.params.id;
      let index = id.indexOf("*");
      if (index !== -1) {
        return id.substring(0, index);
      } else {
        return id;
      }
    },
    show() {
      return this.$route.name !== "SurveyAnswers";
    },
  },
  watch: {
    "$route.name"(val) {
      this.activeIndex = this.tabs.findIndex(
        (item) => val.indexOf(item.route) !== -1
      );
    },
  },
  mounted() {
    this.activeIndex = this.tabs.findIndex(
      (item) => this.$route.name.indexOf(item.route) !== -1
    );
  },
  methods: {
    clickItem(index, route) {
      this.$router.push({
        name: route,
        params: {
          id: this.id,
        },
      });
    },
    downloadData() {
      if (this.activeIndex === 0) {
        exportAnswer(this.id)
          .then((res) => {
            this.downloadFile(res);
          })
          .catch((error) => {
            this.$message({
              message: error.response.data.message,
              type: "error",
              duration: 1500,
              center: true,
            });
          });
      } else if (this.activeIndex === 1) {
        exportAnalyze(this.id)
          .then((res) => {
            this.downloadFile(res);
          })
          .catch((error) => {
            this.$message({
              message: error.response.data.message,
              type: "error",
              duration: 1500,
              center: true,
            });
          });
      }
    },

    downloadMedia() {
      this.downloadDialog.visible = true;
      this.downloadDialog.title = "正在生成";
      this.downloadDialog.url = "";

      exportMedias(this.id).then((res) => {
        this.downloadDialog.url = res.data.download_url;
        this.downloadDialog.title = "开始下载";
        this.downloadFile(res.data.download_url);
        setTimeout(() => {
          this.downloadDialog.visible = false;
        }, 1000);
      });
    },
    downloadFile(url) {
      const a = document.createElement("a");
      a.href = url;
      a.click();
    },
  },
};
</script>

<style lang="less" scoped>
.stat-main {
  width: 1200px;
  margin: 105px auto 0;
  padding: 0 50px;
  box-sizing: border-box;
}

.actionBar {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;

  .function {
    & > div {
      display: inline-block;
    }

    .active {
      color: #1d82fc;
    }
  }

  .item {
    font-size: 14px;
    cursor: pointer;

    img {
      width: 18px;
      height: 18px;
      vertical-align: sub;
      margin-right: 5px;
    }
  }

  .item + .item {
    margin-left: 20px;
  }
}

.dialog-body {
  display: flex;
  position: relative;

  img {
    width: 40px;
    height: 40px;
  }

  .info {
    margin-left: 10px;
  }

  .desc {
    font-size: 12px;
    color: #606266;
  }

  #loading {
    font-size: 20px;
    position: absolute;
    right: 20px;
    top: 10px;
  }
}
</style>